"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addAssociations = addAssociations;
exports.removeAssociation = removeAssociation;

var _ActionTypes = require("crm_data/actions/ActionTypes");

var _BETAssociationsAPI = require("crm_ui/BET/engagementAssociations/api/BETAssociationsAPI");

var _Dispatch = require("crm_data/dispatch/Dispatch");

var _ObjectTypes = require("customer-data-objects/constants/ObjectTypes");

function addAssociations(engagementId, BETServiceAssociations) {
  (0, _BETAssociationsAPI.createServiceEngagementAssociation)(engagementId, BETServiceAssociations.map(function (assoc) {
    return assoc.get('objectId');
  })).then(function () {
    (0, _Dispatch.dispatchImmediate)(_ActionTypes.BET_SERVICE_OBJECT_ASSOCIATIONS_ADD, {
      objectType: _ObjectTypes.ENGAGEMENT,
      engagementId: engagementId,
      BETServiceAssociations: BETServiceAssociations
    });
  }).done();
}

function removeAssociation(engagementId, BETServiceAssociation) {
  (0, _BETAssociationsAPI.removeServiceEngagementAssociation)(engagementId, BETServiceAssociation.get('objectId')).then(function () {
    (0, _Dispatch.dispatchImmediate)(_ActionTypes.BET_SERVICE_OBJECT_ASSOCIATIONS_REMOVE, {
      objectType: _ObjectTypes.ENGAGEMENT,
      engagementId: engagementId,
      BETServiceAssociation: BETServiceAssociation
    });
  }).done();
}